module.exports = __webpack_public_path__ + "img/meme_08.8c99576a.jpg";